/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React, { memo } from "react";
import { Row, Col } from "antd";
import { useSearchParams } from "react-router-dom";

const SignUpSuccessfulScreen = () => {
  const [searchParams] = useSearchParams();
  const redirectCode = searchParams.get("redirectCode");

  const renderRedirectContent = () => {
    if (redirectCode === "1") {
      return (
        <div>
          <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray w-[328px]">
            You can continue your journey on our mobile app.
          </p>
          <button
            type="button"
            className="mt-4 px-4 py-2 h-10.5 lg:w-[312px] w-[328px] bg-primary hover:bg-primary-50 text-background-white disabled:bg-primary rounded-md"
            onClick={() => {
              const deeplink = "myapp://login";
              window.location.href = deeplink;
            }}
          >
            Open App
          </button>
        </div>
      );
    }
    if (redirectCode === "2") {
      return (
        <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray w-[328px]">
          Please continue on our web platform using your computer or laptop.{" "}
        </p>
      );
    }
    if (redirectCode === "3") {
      return (
        <div>
          <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray">
            Please install or open the mobile app on your device.
          </p>
          <button
            type="button"
            className="mt-4 px-4 py-2 h-10.5 lg:w-[312px] w-[328px] bg-primary hover:bg-primary-50 text-background-white disabled:bg-primary rounded-md"
            onClick={() => {
              const deeplink = "myapp://login";
              window.location.href = deeplink;
            }}
          >
            Open App
          </button>
        </div>
      );
    }
    if (redirectCode === "4") {
      return (
        <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray w-[328px]">
          It looks like the mobile app isn’t installed on this device. Please
          contact your admin to get the download link.
        </p>
      );
    }
    return null;
  };
  return (
    <>
      <div className="hidden lg:block w-screen h-screen">
        <Row className="h-full">
          <Col span={15} className="h-full overflow-hidden">
            <img
              src="/assets/images/Login/login-image-new.png"
              alt="LoginImage"
              className="object-cover w-full h-full"
            />
          </Col>

          <Col span={9}>
            <div className="flex flex-col items-center justify-center w-full h-full gap-y-6 bg-background-white">
              <img
                src="/assets/songa-main-logo.svg"
                alt="Songa Mobility"
                className="w-[258px] h-14"
              />

              <div>
                <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray">
                  Sign Up Successful
                </p>
                {renderRedirectContent()}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="block lg:hidden w-screen h-screen">
        <div className="w-full h-[259px] relative">
          <img
            src="/assets/images/Signup/signup-mobile-new.png"
            alt="Signup Header"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex flex-col justify-center pb-6 px-6 gap-8 pt-8">
            <img
              src="/assets/images/Signup/logo.png"
              alt="Songa Mobility"
              className="w-10 h-10"
            />
            <div>
              <p className="text-white text-xl font-semibold">
                Welcome to Songa Mobility!
              </p>
              <p className="text-white/80 text-sm mt-1">
                Please enter your registered email to continue.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-18 flex flex-col items-center">
          {redirectCode !== "4" ? (
            <p className="font-poppins text-xl font-semibold text-center text-black">
              Sign Up complete!
            </p>
          ) : (
            <p className="font-poppins text-xl font-semibold text-center text-black">
              App not installed?
            </p>
          )}
          {renderRedirectContent()}
        </div>
      </div>
    </>
  );
};
export default memo(SignUpSuccessfulScreen);
